var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errorDetails)?_c('div',[_c('h5',[_vm._v("Original error:")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.errorDetails))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }